import Modem from "../api/Modem";
import { ConfigSpec } from "../conf/config";
import { SecretSpec } from "../secret/secret";
import { ServiceSpec } from "../service/service";
import { StackScratchSpec } from "./stack";

const DOCKER_STACK_IMAGE_LABEL = "com.docker.stack.image";
export const DOCKER_STACK_NAMESPACE_LABEL = "com.docker.stack.namespace";

export function createStackFromScratch(modem: Modem, spec: StackScratchSpec) {
    
}